'use strict';

import React from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout     from '@Layout/BackOffice'
import UpdateForm from '@/Form/UpdateForm'
import config     from '@Config/EC/EC_meeting_record'

import Link from '@Pure/Link'

export default class UpdateECMeetingRecordPage extends React.Component
{
	constructor (props)
	{
		super(props);
	}

	componentWillMount ()
	{
		var component = this;

		app.resetFunctions();
	}

	render ()
	{
		const props = this.props;

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		var output =
		(
			<Layout history={ props.history }
				page_title_pathname={ '/accueil/mon-espace/comptes-rendus-de-reunion/modifier' }>

				<div className="page-content">

					<div className="o-content">

						<Link className="c-btn c-btn--extra c-btn--prev u-margin-bottom-10"
							href={ '/accueil/mon-espace/comptes-rendus-de-reunion/' + id }>
							Retourner au compte rendu
						</Link>

						<TransitionGroup className="page-form-container">

							<CSSTransition
								classNames="a-form-transition"
								appear={ true }
								enter={ true }
								exit={ true }
								timeout={{ enter: 240, exit: 320, appear: 500 }}>

								<UpdateForm config={ config } className="u-no-margin-top" />

							</CSSTransition>

						</TransitionGroup>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}